export const getSurfaceDisplayLabel = (surface: string): string => {
  switch (surface.toLowerCase()) {
    case 'scm':
      return 'Source Code';
    default:
      return surface.charAt(0).toUpperCase() + surface.slice(1).toLowerCase();
  }
};
